import { render, staticRenderFns } from "./AdminPanelDasboardItem.vue?vue&type=template&id=48bb7c65"
import script from "./AdminPanelDasboardItem.vue?vue&type=script&lang=js"
export * from "./AdminPanelDasboardItem.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDasboardItem.vue?vue&type=style&index=0&id=48bb7c65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports